import { render, staticRenderFns } from "./facility.vue?vue&type=template&id=1b40536b&scoped=true&"
import script from "./facility.vue?vue&type=script&lang=js&"
export * from "./facility.vue?vue&type=script&lang=js&"
import style0 from "./facility.vue?vue&type=style&index=0&id=1b40536b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40536b",
  null
  
)

export default component.exports